export default __webpack_public_path__ + "static/media/services-header-image-mobile.306d493d.png";